import React from 'react'
import { Card, Grid, Image } from 'semantic-ui-react'
import bestTeamsImg from '../assets/1485972550847_lc_galleryImage_MANCHESTER_ENGLAND_FEBRUA.JPG'
import professionalPlayersImg from '../assets/paul_pogba_juan_mata_professional_players.jpg'
import becomeTheManagerImg from '../assets/alexander-londono-322213.jpg'

// <h2>Dream Team</h2>
const FeatureCards = () => (
  <div className='feature-cards'>
      <Grid>
        <Grid.Column width={16}>
          <Card.Group itemsPerRow={3}>
            <Card href='/clubs'>
              <Image style={{height: '100%', width: '100%', objectFit: 'cover'}} src={bestTeamsImg} />
              <Card.Content>
                <Card.Header>All The Best Teams</Card.Header>
                <Card.Description>Explore soccer like never before! Discover the lineups and player attributes of top teams, whether your favorite or others. Analyze player ratings, strengths, and weaknesses for a deeper understanding of the game.</Card.Description>
              </Card.Content>
            </Card>
            <Card href='/players'>
              <Image style={{height: '100%', width: '100%', objectFit: 'cover'}} src={professionalPlayersImg}/>
              <Card.Content>
                <Card.Header>Every Professional Player</Card.Header>
                <Card.Description>Every pro player is here. Explore comprehensive player profiles with ratings in various categories from 0 to 100. Uncover hidden talents and assess your favorite stars. It's a hub for fans and analysts to appreciate the world of soccer.</Card.Description>
              </Card.Content>
            </Card>
            <Card href='/tutorial'>
              <Image style={{height: '100%', width: '100%', objectFit: 'cover'}} src={becomeTheManagerImg}/>
              <Card.Content>
                <Card.Header>Become The Manager</Card.Header>
                <Card.Description>Take control! Shape your dream team's formation and select the best players. Experiment with combinations, adjust tactics, and see real-time rating changes. Step into the role of a soccer coach and craft your ideal lineup. The power is in your hands, ready for the challenge?</Card.Description>
              </Card.Content>
            </Card>
          </Card.Group>
        </Grid.Column>
      </Grid>
    </div>
)

export default FeatureCards



// WEBPACK FOOTER //
// ./src/components/FeatureCards.js